import React from 'react';
import i18n from 'asset/translation';
import Dashboard from 'domain/entity/dashboard';
import { StyledGreyTag } from 'adapter/in/reports/containers/ReportListsStyles';
import { getReportTemplateAuthorTagText } from 'adapter/in/reports/components/ReportTemplatesAuthorColumn/useReportTemplateAuthorColumn';

export const useDashboardsAuthorColumn = (onCell?: (record: any) => React.TdHTMLAttributes<HTMLElement>) => ({
    title: i18n.t('dashboards.author'),
    dataIndex: '',
    width: '15%',
    className: 'remove-border',
    onCell,
    render: (dashboard: Dashboard) => {
        const text = getReportTemplateAuthorTagText(dashboard);
        return <StyledGreyTag>{text}</StyledGreyTag>;
    },
});
